var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import CartItemModel from "./CartItemModel";
import { forEach, flatten } from 'lodash';
var RecentOrderItem = /** @class */ (function (_super) {
    __extends(RecentOrderItem, _super);
    function RecentOrderItem(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _this.useHydrator(data);
        _this.id = hydrated.id;
        _this.image = hydrated.image;
        _this.price = hydrated.price;
        _this.quantity = hydrated.quantity;
        _this.options = hydrated.options;
        _this.description = hydrated.description;
        _this.name = hydrated.name;
        _this.taxes = hydrated.taxes;
        _this.status = hydrated.status;
        _this.options = hydrated.options;
        _this.outOfStock = hydrated.outOfStock;
        return _this;
    }
    RecentOrderItem.prototype.hydrate = function (data) {
        var recentOrder = {};
        recentOrder.id = data.id || data.assetId;
        recentOrder.image = data.image;
        recentOrder.price = data.price || 0;
        recentOrder.quantity = data.qty || data.quantity;
        recentOrder.options = data.options || [];
        recentOrder.description = data.description || "";
        recentOrder.name = data.name || "";
        recentOrder.taxes = data.taxes || "";
        recentOrder.status = parseInt(data.status) || 0;
        recentOrder.outOfStock = data.outOfStock === "0" || data.out_of_stock === "0";
        return recentOrder;
    };
    RecentOrderItem.prototype.recentScriptHydrator = function (data) {
        // apply options to whole side
        // not on siblings?  sibId === "1"
        // in sibs but not in base? sibid === "2"
        var item = {};
        item.id = data.id || data.assetId || data.asset_id;
        item.quantity = data.quantity || data.qty || 1;
        item.assetId = data.assetId;
        item.image = data.image;
        item.description = data.description || "";
        item.price = parseInt(data.price) || 0;
        item.name = data.name || "";
        item.status = parseInt(data.status) || 0;
        item.options = [];
        item.outOfStock = data.outOfStock === "0" || data.out_of_stock === "0";
        return item;
    };
    RecentOrderItem.prototype.restoreFromItem = function (menuItem) {
        this.name = menuItem.name;
        this.price = menuItem.price;
        this.categoryId = menuItem.categoryId;
        this.discounts = [menuItem.discount];
        this.image = menuItem.image;
        if (this.bundle) {
            this.bundle = this.restoreBundle(this.bundle, menuItem);
        }
    };
    // Bundle top level item
    RecentOrderItem.prototype.restoreBundle = function (bundle, menuItem) {
        var groups = bundle.groups;
        var restoredBundle = null;
        var lineItems = [];
        forEach(groups, function (group) {
            var groupItems = group.extractLineItems();
            lineItems.push(groupItems);
        });
        lineItems = flatten(lineItems);
        restoredBundle = menuItem.bundle;
        forEach(restoredBundle.groups, function (group) {
            group.restore(lineItems);
        });
        restoredBundle.extractLineItemsFromGroups();
        return restoredBundle;
    };
    RecentOrderItem.prototype.useHydrator = function (data) {
        var hydrationStrategy = data.hydrationStrategy || "hydrate";
        return this[hydrationStrategy](data);
    };
    return RecentOrderItem;
}(CartItemModel));
export default RecentOrderItem;



//////////////////
// WEBPACK FOOTER
// ./src/models/RecentOrderItem.ts
// module id = 19+v
// module chunks = 18